export default {"src":"/_next/static/media/phantom.19f37c01.svg","height":32,"width":32};